import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./loadingIcon.style.css";
export const LoadingIcon = () => {
    return (_jsxs("div", { className: "loading4Wrap", children: [_jsx("div", { className: "loading4_1" }), _jsx("div", { className: "loading4_2" }), _jsx("div", { className: "loading4_3" }), _jsx("div", { className: "loading4_4" }), _jsx("div", { className: "loading4_5" })] }));
};
